<template>
  <div class="matches_list" style="cursor:pointer"  @click="gotoIndexdetail(gamedata)">
    <div class="box_bg">
      <div class="left" :style="{ 'background-color': '#'+gamedata.HomeTeam.PrimaryColor }">
        <div class="left_angle" :style="{ 'border-top-color': '#'+gamedata.HomeTeam.PrimaryColor }"> </div>
      </div>
      <div class="right" :style="{ 'background-color': '#'+gamedata.AwayTeam.PrimaryColor }"></div>
    </div>
    <div class="teams_cnt">
      <!-- <span class="match_status" v-if="gamedata.Status == 'InProgress'">
        <template>LIVE</template>
      </span> --> 
    <div class="live-alert" v-if="gamedata.Status == 'InProgress'">
      <div class="waveWrapper left">
        <div class="waveWrapperInner delay1">
          <div class="wave"></div>
        </div>
        <div class="waveWrapperInner delay2">
          <div class="wave"></div>
        </div>
        <div class="waveWrapperInner delay3">
          <div class="wave"></div>
        </div>
      </div>
      <div class="wave-text">
        <div class="text-wrapper">
          <h2>Live</h2>
        </div>
      </div>
      <div class="waveWrapper right">
          <div class="waveWrapperInner delay1">
            <div class="wave"></div>
          </div>
          <div class="waveWrapperInner delay2">
            <div class="wave"></div>
          </div>
          <div class="waveWrapperInner delay3">
            <div class="wave"></div>
          </div>
      </div>
    </div>
      <div class="team_logs">
        <figure>
          <img :title="gamedata.HomeTeam.Name"  :src="gamedata.HomeTeam.logo" />

          <figcaption v-if="gamedata.LiveProb">{{ gamedata.LiveProb.home_score }}</figcaption>
        </figure>
        <div class="score_cnt">
          <span><img src="@/assets/images/vs.svg" /></span>
          <p v-if="gamedata.Status == 'InProgress'">
            Scores
            <b>{{elapsedTime}}</b>
          </p>
            <p v-else-if="gamedata.Status == 'Scheduled'">
            Starts In
            <b>{{startsIn}}</b>
          </p>
            <p v-else>
           {{gamedata.Status}}
          </p>
        </div>

        <figure>
          <img  :src="gamedata.AwayTeam.logo" :title="gamedata.AwayTeam.Name" />
          <figcaption v-if="gamedata.LiveProb">{{ gamedata.LiveProb.away_score }}</figcaption>
          </figure>
      </div>
      <div class="prodiction">
        <div class="prodiction_btn">
          <h4>ProFitX - Prediction</h4>
        </div>
        <div class="prodiction_value" v-if="gamedata.Status != 'InProgress'">
          <p>
              <template v-if="HomeWinPer > AwayWinPer">Winning</template>
              <template v-if="HomeWinPer < AwayWinPer">Losing</template>

            <b>{{ HomeWinPer | percentagecustom(1)
              }}%</b>
          </p>
          <p><b>{{ AwayWinPer | percentagecustom(1)
              }}%</b>              <template v-if="AwayWinPer > HomeWinPer">Winning</template>
              <template v-if="AwayWinPer < HomeWinPer">Losing</template></p>
        </div>
              <div class="prodiction_value" v-if="gamedata.Status == 'InProgress'">
          <p>
              <template v-if="gamedata.LiveProb.home_win_pct > gamedata.LiveProb.away_win_pct">Winning</template>
              <template v-if="gamedata.LiveProb.home_win_pct < gamedata.LiveProb.away_win_pct">Losing</template>

            <b>{{ gamedata.LiveProb.home_win_pct | percentagecustom(1)
              }}%</b>
          </p>
          <p><b>{{ gamedata.LiveProb.away_win_pct | percentagecustom(1)
              }}%</b>              <template v-if="gamedata.LiveProb.away_win_pct > gamedata.LiveProb.home_win_pct">Winning</template>
              <template v-if="gamedata.LiveProb.away_win_pct < gamedata.LiveProb.home_win_pct">Losing</template></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  components: {},
  props: {
    gamedata: null,
  },
  mounted() {
    this.siteUrl = process.env.VUE_APP_API_URL;
    // Start timer for live games
    if (this.gamedata && this.gamedata.Status === 'InProgress') {
      this.startElapsedTimer();
    }
  },
  beforeDestroy() {
    // Clear timer when component is destroyed
    if (this.elapsedTimer) {
      clearInterval(this.elapsedTimer);
    }
  },
  watch: {
    'gamedata.Status'(newStatus) {
      // Start/stop timer based on status
      if (newStatus === 'InProgress' && !this.elapsedTimer) {
        this.startElapsedTimer();
      } else if (newStatus !== 'InProgress' && this.elapsedTimer) {
        clearInterval(this.elapsedTimer);
        this.elapsedTimer = null;
      }
    }
  },
  computed: {
    elapsedTime() {
      // Calculate elapsed time in real-time for InProgress games
      if (this.gamedata && this.gamedata.Status === 'InProgress' && this.gamedata.DateTimeUTC) {
        const gameStartTime = moment.utc(this.gamedata.DateTimeUTC);
        const now = moment.utc();
        const diffSeconds = now.diff(gameStartTime, 'seconds');
        
        if (diffSeconds < 0) {
          return "00:00";
        }
        
        // Format as MM:SS (minutes:seconds)
        const minutes = Math.floor(diffSeconds / 60);
        const seconds = diffSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }
      
      // Fallback to LiveProb.elapsed if available
      if (this.gamedata && this.gamedata.LiveProb && this.gamedata.LiveProb.elapsed) {
        return this.gamedata.LiveProb.elapsed;
      }
      
      return "00:00";
    },
    isUserloggeIn() {
      return this.$store.state && this.$store.state.user != "";
    },
     HomeWinPer(){
      if(this.gamedata.Status == "InProgress" || this.gamedata.Status == "Final"){

        return this.gamedata.LiveProb.home_win_pct
      }
      return this.gamedata.home_win_pct
    },
    AwayWinPer(){
      if(this.gamedata.Status == "InProgress" || this.gamedata.Status == "Final"){

        return this.gamedata.LiveProb.away_win_pct
      }
      return this.gamedata.away_win_pct
    },
    startsIn() {
      // DateTimeUTC is already in UTC format from API, use it directly
      const gameDateTime = this.gamedata.DateTimeUTC || "";
      if (!gameDateTime) {
        return "N/A";
      }
      
      // Ensure it's treated as UTC (add Z if not present)
      const utcDateTime = gameDateTime.endsWith('Z') ? gameDateTime : gameDateTime + 'Z';
      
      if (
        moment
          .utc(utcDateTime)
          .isAfter(moment().utc())
      ) {
        var _t = moment.utc(utcDateTime).diff(moment().utc(), "hours");
        if(_t <= 0){
          _t = moment.utc(utcDateTime).diff(moment().utc(), "minutes");
          return _t +" Minutes"
        }else{
          return _t +" Hours"
        }
      }
      var _z = moment()
        .utc()
        .diff(moment.utc(utcDateTime), "hours");
        if(_z <= 0){
          _z = moment()
        .utc()
        .diff(moment.utc(utcDateTime), "minutes");
          return _z +" Minutes"
        }else{
          return _z +" Hours"
        }
   
    },
    iscompleted() {
      return moment().isBefore(moment(this.gamedata.gamedatee));
    },
    livematch() {
      return (
        moment().isSameOrAfter(moment(this.gamedata.gamedate)) &&
        moment().isSameOrBefore(moment(this.gamedata.gamedatee))
      );
    },
    getHTeamlogo() {
      return this.gamedata.HomeTeam.NbaDotComTeamID;
    },
    getaTeamlogo() {
      return this.gamedata.AwayTeam.NbaDotComTeamID;
    },
  },

  methods: {
    gotoIndexdetail(data) {
      if (this.isUserloggeIn) {
        this.$router.push({
          name: "probability-details",
          params: { id: data.gameid},
        });
      } else {
        this.$emit("triggerSignup");
      }
    },
    startElapsedTimer() {
      // Update elapsed time every second
      this.elapsedTimer = setInterval(() => {
        // Force reactivity update
        this.$forceUpdate();
      }, 1000);
    },
  },
  data() {
    return {
      tab: null,
      siteUrl: null,
      elapsedTimer: null,
      linupslider1: {
        slidesPerView: "auto",
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".next1",
          prevEl: ".prev1",
        },
      },
      linupslider2: {
        slidesPerView: "auto",
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".next2",
          prevEl: ".prev2",
        },
      },
    };
  },
};
</script>
